import SupportContent from './SupportContent';

export default SupportContent;
